/**
 * @generated SignedSource<<5eab495460d9c9184cead9315741adff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternPrivacyWebhooksStatsQuery$variables = {
  days: number;
};
export type InternPrivacyWebhooksStatsQuery$data = {
  readonly internPrivacyWebhookStats: {
    readonly completed: number;
    readonly failed: number;
    readonly pending: number;
    readonly processing: number;
    readonly successRate: number;
    readonly total: number;
  };
};
export type InternPrivacyWebhooksStatsQuery = {
  response: InternPrivacyWebhooksStatsQuery$data;
  variables: InternPrivacyWebhooksStatsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "days"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "days",
        "variableName": "days"
      }
    ],
    "concreteType": "PrivacyWebhookStats",
    "kind": "LinkedField",
    "name": "internPrivacyWebhookStats",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processing",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successRate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternPrivacyWebhooksStatsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternPrivacyWebhooksStatsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6c0c8cd0d473f0dffe7b732b90fc261",
    "id": null,
    "metadata": {},
    "name": "InternPrivacyWebhooksStatsQuery",
    "operationKind": "query",
    "text": "query InternPrivacyWebhooksStatsQuery(\n  $days: Int!\n) {\n  internPrivacyWebhookStats(days: $days) {\n    total\n    pending\n    processing\n    completed\n    failed\n    successRate\n  }\n}\n"
  }
};
})();

(node as any).hash = "a91353b59dae9537970f474d0f3900a6";

export default node;
